// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function CaretLeft(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "CaretLeft" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14 7L14 17L9 12L14 7Z", fill: "currentColor" }))));
});
//# sourceMappingURL=CaretLeft.js.map